import React from "react";
import Header from "../Components/Header";

function Contact() {
  return (
    <>
      <Header />
      <div className="contact-page">
        <h1>
          For any question, please mail me at birdievsq@gmail.com <br /> or,
          <br /> Contact me at +2348102588140
        </h1>
      </div>
    </>
  );
}

export default Contact;
